import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  CIBUS_DIRECTION_OPTIONS,
  CIBUS_KIND_OPTIONS,
  CIBUS_STATUS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type CibusCallLogsFiltersProps = Pick<
  UseMonitoringPage,
  | 'cibusTenantFilter' | 'setCibusTenantFilter'
  | 'cibusTenantOptions'
  | 'cibusDirectionFilter' | 'setCibusDirectionFilter'
  | 'cibusKindFilter' | 'setCibusKindFilter'
  | 'cibusStatusFilter' | 'setCibusStatusFilter'
  | 'cibusSearch' | 'setCibusSearch'
  | 'cibusDateFilterMode' | 'setCibusDateFilterMode'
  | 'cibusExactDate' | 'setCibusExactDate'
  | 'cibusDateFrom' | 'setCibusDateFrom'
  | 'cibusDateTo' | 'setCibusDateTo'
  | 'clearCibusFilters'
>;

export const CibusCallLogsFilters: React.FC<CibusCallLogsFiltersProps> = ({
  cibusTenantFilter,
  setCibusTenantFilter,
  cibusTenantOptions,
  cibusDirectionFilter,
  setCibusDirectionFilter,
  cibusKindFilter,
  setCibusKindFilter,
  cibusStatusFilter,
  setCibusStatusFilter,
  cibusSearch,
  setCibusSearch,
  cibusDateFilterMode,
  setCibusDateFilterMode,
  cibusExactDate,
  setCibusExactDate,
  cibusDateFrom,
  setCibusDateFrom,
  cibusDateTo,
  setCibusDateTo,
  clearCibusFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={cibusTenantOptions}
          value={cibusTenantFilter || null}
          onChange={(value) => setCibusTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-cibus-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'כיוון'}
          placeholder={'בחר כיוון'}
          data={CIBUS_DIRECTION_OPTIONS}
          value={cibusDirectionFilter || null}
          onChange={(value) => setCibusDirectionFilter(value ?? '')}
          clearable
          data-testid="monitoring-cibus-filter-direction"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סוג'}
          placeholder={'בחר סוג'}
          data={CIBUS_KIND_OPTIONS}
          value={cibusKindFilter || null}
          onChange={(value) => setCibusKindFilter(value ?? '')}
          clearable
          data-testid="monitoring-cibus-filter-kind"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סטטוס'}
          placeholder={'בחר סטטוס'}
          data={CIBUS_STATUS_OPTIONS}
          value={cibusStatusFilter || null}
          onChange={(value) => setCibusStatusFilter(value ?? '')}
          clearable
          data-testid="monitoring-cibus-filter-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה או מזהה בקשה'}
          value={cibusSearch}
          onChange={(event) => setCibusSearch(event.currentTarget.value)}
          data-testid="monitoring-cibus-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={cibusDateFilterMode}
          onChange={(value) => setCibusDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-cibus-date-mode"
        />
        {cibusDateFilterMode === 'exact' && (
          <TextInput type="date" value={cibusExactDate} onChange={(event) => setCibusExactDate(event.currentTarget.value)} data-testid="monitoring-cibus-date-exact" />
        )}
        {cibusDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={cibusDateFrom} onChange={(event) => setCibusDateFrom(event.currentTarget.value)} data-testid="monitoring-cibus-date-from" />
            <TextInput type="date" value={cibusDateTo} onChange={(event) => setCibusDateTo(event.currentTarget.value)} data-testid="monitoring-cibus-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearCibusFilters} dataTestId="monitoring-cibus-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
